export default __webpack_public_path__ + "static/media/Download_App_Store.8c4986ee.svg";